export class OrderDto {
    locked: boolean;
    acceptedDate: string;
    origin: string;
    subscriptionId: string;
    mechCode: string;
    domainLics: number;
    fullName: string;
    licenseType: string;
    networkUserId: number;
    randomId: string;
    backofficeOrderId: string;
    slotCount: number;
    userEmail: string;
    startDate: string;
    dbStartDate: string;
    expireDate: string;
    dbExpireDate: string;
    creationDate: string;
    createdBy: string;
    lastModificationDate: string;
    lastModificationBy: string;
    lastAction: string;
    suspended: boolean;
    userType: string;
    planId: string;
    ocrMathScanQuota: number;
    ocrMathScanPolicy: string;
    ocrMathScansLeft: string;
    isOcrMathScansLeftDone: boolean;
    notes: string;
    z_history: any;
    TBD: boolean;
    days: number;
    redirectId: string;
    aiCredits: number;

    constructor(json: any = null) {
        if (!json) {
            json = {};
        }
        this.locked = json.locked || false;
        this.acceptedDate = json.acceptedDate || '';
        this.origin = json.origin || '';
        this.subscriptionId = json.subscriptionId || '';
        this.mechCode = json.mechCode || '';
        this.domainLics = json.domainLics || 0;
        this.fullName = json.fullName || '';
        this.licenseType = json.licenseType || '';
        this.networkUserId = json.networkUserId || 0;
        this.randomId = json.randomId || '';
        this.backofficeOrderId = json.backofficeOrderId || '';
        this.slotCount = json.slotCount || 0;
        this.userEmail = json.userEmail || '';
        this.dbStartDate = json.startDate || '2000-01-01';
        this.userType = (json && json.userType ? json.userType : '');
        this.planId = (json && json.planId ? json.planId : 'maps');
        this.ocrMathScanQuota = (json && json.ocrMathScanQuota ? parseInt(json.ocrMathScanQuota) : 0);
        this.ocrMathScanPolicy = (json && json.ocrMathScanPolicy ? json.ocrMathScanPolicy : 'FREE');
        this.ocrMathScansLeft = '';
        this.isOcrMathScansLeftDone = false;
        if (json.startDate) {
            const [year, month, day]: string[] = this.dbStartDate.split('-');
            this.startDate = `${day}/${month}/${year}`;
        } else {
            this.startDate = '';
        }
        this.dbExpireDate = json.expireDate;
        if (json.expireDate) {
            const [year, month, day]: string[] = this.dbExpireDate.split('-');
            this.expireDate = `${day}/${month}/${year}`;
        } else {
            this.expireDate = '';
        }
        this.creationDate = json.creationDate;
        this.createdBy = json.createdBy || '';
        this.lastModificationDate = json.lastModificationDate;
        this.lastModificationBy = json.lastModificationBy || '';
        this.lastAction = json.lastAction || '';
        this.suspended = (json.suspended ? json.suspended : false);
        this.notes = (json.notes ? json.notes : '');
        this.z_history = (json.z_history ? json.z_history : null);
        this.TBD = (json.TBD === 1);
        this.days = (json.days ? json.days : 0);
        this.redirectId = (json.redirectId ? json.redirectId : '');
        this.aiCredits = (json.aiCredits ? json.aiCredits : -1);
    }
}
